/**
 * BİLDİRİMDEN EKRANA — F-NTF-09, öğrenci uygulaması
 *
 * Şartname: *"Satır, bildirimi doğuran kayda gider."* Bildirimin
 * `linkUrl` alanı bir yol taşıyor (`/raporlar/abc123`); bu uygulamada
 * yönlendirici yok, hangi ekranın açık olduğunu durum tutuyor. Yolu
 * ekrana çevirmek bu dosyanın işi.
 *
 * ================================================================
 * PANELİN TABLOSU BURAYA KOPYALANMADI — BİLEREK
 * ================================================================
 * `apps/panel/src/bildirim-yonlendirme.ts` on dört yol tanıyor.
 * Hepsi PANELİN ekran anahtarları: `finans`, `yedek`, `loglar`…
 * Burada karşılıkları YOK ve olmamalı.
 *
 * Bu dosya YALNIZCA bu uygulamanın gerçekten açabildiği yolu tanıyor.
 * Ölçüldü (07.09.2026): bugün öğrenci ya da veliye bildirim üreten
 * beş çağrı yeri var ve `linkUrl` taşıyan yalnızca ikisi —
 * `/raporlar/<raporId>` (veli gelişim raporu) ve
 * `/anket/<token>` (memnuniyet anketi).
 *
 * ================================================================
 * ANKET YOLU TANINMIYOR — SAYFASI YOK
 * ================================================================
 * `/anket/<token>` bu depoda hiçbir uygulamada karşılığı olmayan bir
 * yol: anket sayfası henüz yazılmadı. Tabloya "anket" satırı eklemek
 * kolay olurdu ve düğme basıldığında hiçbir şey olmazdı.
 *
 * Panelin kendi notu bu dersi zaten yazmış: *"basılıp hiçbir şey
 * olmayan bir düğme, olmayan bir düğmeden kötüdür."* Yol tanınana
 * kadar bildirim satırı düğmesiz duruyor — başlık ve gövde okunuyor,
 * yalnızca gidilecek yer sunulmuyor.
 */

/** Bu uygulamada bildirimin götürebileceği yerler. */
export interface YonlendirmeHedefi {
  /**
   * Hedef görünüm.
   *
   * Bugün tek değer var (`veli-rapor`). Yine de birleşim (union) tipi:
   * ikinci bir yol eklendiğinde çağıran taraf `switch`i tamamlamadan
   * DERLENMESİN — eksik dal, sessizce hiçbir yere gitmeyen bir düğme
   * demek olurdu.
   */
  gorunum: "veli-rapor";
  /** Açılacak kaydın kimliği. */
  kayitId: string;
}

/**
 * `linkUrl`i bu uygulamanın bir görünümüne çevirir.
 *
 * @returns tanınmayan, boş ya da bu uygulamanın dışındaki bir yol için `null`
 */
export function bildirimHedefi(linkUrl: string | null): YonlendirmeHedefi | null {
  if (linkUrl === null) return null;

  const temiz = linkUrl.trim();
  if (temiz === "") return null;

  /*
    DIŞ BAĞLANTI EKRAN ANAHTARI SANILMIYOR. Duyuru bildirimi serbest
    bir URL taşıyabiliyor (`operasyon.controller.ts` `baglanti` alanı).
    "https://..." ile başlayan bir yolun ilk parçasını ekran adı
    sanmak, kullanıcıyı alakasız bir ekrana götürürdü.
  */
  if (/^[a-z][a-z0-9+.-]*:/i.test(temiz)) return null;
  if (temiz.startsWith("//")) return null;

  const parcalar = temiz.replace(/^\/+/, "").split("/").filter(Boolean);
  if (parcalar[0] !== "raporlar") return null;

  const kayitId = parcalar[1];
  /*
    KİMLİKSİZ "/raporlar" TANINMIYOR. Panelde `raporlar` tek başına
    bir EKRAN; burada değil — veli portalında rapor listesi zaten
    ana sayfada duruyor ve "rapor listesine git" düğmesi kullanıcıyı
    bulunduğu yere götürürdü.
  */
  if (!kayitId) return null;

  return { gorunum: "veli-rapor", kayitId };
}
